import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Check, Phone, Mail, ArrowRight } from 'lucide-react';
import { company, constructionFaqs } from '../mock';
import { FaqAccordion } from '../sections/RestSections';

import Seo from '../components/Seo';
import StructuredData from '../components/StructuredData';

const commercialWork = [
  { img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_lowcountry-test/artifacts/s0thcs0i_07%3A18%3A26.4.jpg', title: 'Commercial Restaurant Build-Out' },
  { img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_lowcountry-test/artifacts/smqk9f4i_07%3A18%3A26.webp', title: 'Kitchen Sinks & Grease Trap' },
  { img: 'https://customer-assets-gfyr7b9c.emergentagent.net/job_lowcountry-test/artifacts/y5b9iuh1_07%3A18%3A26.8.webp', title: 'Commercial Kitchen Plumbing' },
];

const commercialServices = [
  'Drain cleaning & repair',
  'Faucet installation & repair',
  'Toilet installation & repair',
  'Water heater installation & repair',
  'Gas installation & repair',
  'Water pressure regulators',
  'Sewer repair',
  'Fixture installation',
  'Sewage pump service & replacement',
  'Slab leak detection & repair',
  'Backflow inspection, repair & installation',
];

export default function CommercialPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);
  return (
    <main className="page services-page">
      <Seo title="Commercial Plumbing in Savannah" description="Commercial & industrial plumbing in Savannah, GA: drain cleaning, water heaters, gas lines, backflow prevention, grease traps, build-outs & repipes." path="/commercial" />
      <StructuredData faqItems={constructionFaqs} />
      <section className="page-hero">
        <div className="wrap">
          <p className="eyebrow">Commercial &amp; Industrial</p>
          <h1>Plumbing that keeps your business running</h1>
          <p className="lede">
            Victory Plumbing provides comprehensive commercial plumbing for business owners across Savannah
            and the surrounding communities. We specialize in every aspect of the trade, delivering
            state-of-the-art expertise with customer satisfaction as our top priority.
          </p>
        </div>
      </section>

      <section className="about-body">
        <div className="wrap">
          <div className="sec-head" style={{ marginBottom: '32px' }}>
            <p className="eyebrow">What We Offer</p>
            <h2>Top commercial services</h2>
            <p>Dependable workmanship for restaurants, offices, retail, and industrial facilities alike.</p>
          </div>
          <div className="val-grid">
            {commercialServices.map((s) => (
              <div className="val-item" key={s}>
                <span className="ic"><Check size={18} /></span>
                <span>{s}</span>
              </div>
            ))}
          </div>
          <div className="svc-links">
            <span>Explore our project services:</span>
            <Link to="/commercial/new-construction">New Construction <ArrowRight size={13} /></Link>
            <Link to="/commercial/large-scale-renovations">Large-Scale Renovations <ArrowRight size={13} /></Link>
            <Link to="/commercial/large-plumbing-projects">Large Plumbing Projects <ArrowRight size={13} /></Link>
            <Link to="/commercial/contractor-services">Contractor Services <ArrowRight size={13} /></Link>
          </div>
        </div>
      </section>

      <section className="work-section">
        <div className="wrap">
          <div className="sec-head" style={{ marginBottom: '28px' }}>
            <p className="eyebrow">Recent Commercial Work</p>
            <h2>Projects across the Coastal Empire</h2>
            <p>A look at some of the commercial jobs our team has recently completed.</p>
          </div>
          <div className="work-grid">
            {commercialWork.map((w) => (
              <Link to="/gallery" className="work-card" key={w.title} data-testid="commercial-photo-link">
                <img src={w.img} alt={w.title} loading="lazy" />
                <span className="work-cap">{w.title}</span>
              </Link>
            ))}
          </div>
          <div className="work-actions">
            <Link className="btn btn-gold" to="/gallery" data-testid="commercial-view-gallery">View Full Gallery <ArrowRight size={16} /></Link>
          </div>
        </div>
      </section>

      <section className="about-body" style={{ paddingTop: 0 }}>
        <div className="wrap">
          <div className="about-craft">
            <p className="eyebrow" style={{ justifyContent: 'center' }}>Remodeling &amp; Repiping</p>
            <h3>Build-outs and repipes done right</h3>
            <p>
              From tenant build-outs to full repipes and fixture installation, our team plans and executes
              commercial renovations with an eye on uptime, safety, and code compliance &mdash; including
              experience with Savannah&rsquo;s historic structures.
            </p>
            <div className="about-cta" style={{ justifyContent: 'center' }}>
              <Link className="btn btn-gold" to="/contact"><Mail size={16} /> Get in Touch</Link>
              <a className="btn btn-outline-dark" href={company.phoneHref}><Phone size={15} /> {company.phoneDisplay}</a>
            </div>
          </div>
        </div>
      </section>

      <section className="faq-full" data-testid="commercial-faqs">
        <div className="wrap">
          <div className="sec-head" style={{ marginBottom: '28px' }}>
            <p className="eyebrow">Common Questions</p>
            <h2>Construction plumbing FAQs</h2>
            <p>What to expect on new construction, remodels, repipes, permits, and scheduling.</p>
          </div>
          <FaqAccordion items={constructionFaqs.slice(0, 4)} />
          <div className="faq-actions">
            <Link className="btn btn-outline-dark" to="/faq" data-testid="commercial-view-all-faqs">View All FAQs</Link>
          </div>
        </div>
      </section>
    </main>
  );
}
